// Availability type definitions

export interface TimeSlot {
  id?: string;           // UUID from DB (undefined for new)
  startTime: string;     // "HH:mm" format (24h)
  endTime: string;       // "HH:mm" format (24h)
}

export interface DaySchedule {
  isEnabled: boolean;    // Checkbox state
  slots: TimeSlot[];     // Multiple time windows
}

export interface RecurringSchedule {
  [dayOfWeek: number]: DaySchedule; // 0-6 = Sun-Sat
}

export interface OneTimeSchedule {
  [dateString: string]: DaySchedule; // "2026-01-18" format
}

// Database record
export interface StaffAvailabilityRecord {
  id?: string;
  staff_id: string;
  day_of_week: number | null;
  start_time: string;     // "HH:mm:ss"
  end_time: string;       // "HH:mm:ss"
  is_recurring: boolean;
  specific_date: string | null;  // "YYYY-MM-DD"
  notes?: string;
}

// Staff member from team table
export interface StaffMember {
  id: string;
  name: string;
  role: string;
  photo: string;
}

// Day names for display
export const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const DAY_NAMES_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
